var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","flat":"","color":_vm.$vuetify.theme.dark ? '#121212' : 'white'}},[_c('v-spacer'),_c('img',{attrs:{"src":`/assets/logo/${_vm.logoName}.png`,"contain":"","alt":_vm.altText,"height":"52"}}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }